import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./regular-asset-component.scss";
import Colors from "styles/colors";
import AssetComponent from "components/core/asset/asset-component";
import { withGenericConfig } from "contexts/generic-config-context";
import { AUTO } from "constants/cloudinary-asset-qualities";

class RegularAssetComponent extends PureComponent {
  render() {
    const {
      isMobileOrTabletBrowser,
      backgroundColor,
      width,
      mobileWidth,
      position,
      asset,
      assetQuality,
      useDynamicAsset,
      hideControls,
      dynamicAssetParamPath,
      fullWidth,
      useWindowMask,
      minHeight
    } = this.props;
    const finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
    const widthInPercentage = finalWidth ? `${finalWidth}%` : "auto";

    return (
      <div className="regular-asset-component" style={{ backgroundColor: Colors[backgroundColor], minHeight }}>
        <div className={classnames("asset-component-wrapper", position, { "full-width": fullWidth })}>
          <AssetComponent
            {...asset}
            assetQuality={assetQuality}
            useDynamicAsset={useDynamicAsset}
            hideControls={hideControls}
            width={widthInPercentage}
            convertGifToVideo={true}
            className="regular-asset-image-wrapper"
            imageClassName="regular-asset-image"
            dynamicAssetParamPath={dynamicAssetParamPath}
            useWindowMask={useWindowMask}
          />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

RegularAssetComponent.defaultProps = {
  width: 100,
  position: "center",
  asset: {
    image: {
      src: "/static/img/segment-layout-default-images/asset/timeline-view.png"
    }
  },
  assetQuality: AUTO,
  fullWidth: false
};

export default withGenericConfig(RegularAssetComponent);
